<template>
  <div class="t-riderlist">
    <div class="t-rider-list">
      <p class="t-rider-title">骑手列表</p>
      <div class="t-rider-search">
        <el-select
          multiple
          collapse-tags
          placeholder="全部骑手"
          size="small"
          :value="workStatus"
          class="t-rider-search-select"
          @input="handleSelectWorkStatus"
        >
          <el-option
            v-for="item in riderStatusList"
            filterable
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.value !== 0 && workStatus.includes(0)">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="t-table">
      <el-table
        :data="list"
        :height="height"
        size="mini"
        border
        >
        <el-table-column
          prop="rider_id"
          width="70"
          label="骑手ID">
        </el-table-column>
        <el-table-column
          prop="rider_name"
          width="120"
          label="骑手姓名">
          <template slot-scope="scope">
            <span class="square-button red" @click="handleRiderOrderMode(scope.row)">图</span>
            {{scope.row.rider_name}}
          </template>
        </el-table-column>
        <el-table-column
          prop="work_status"
          width="60"
          label="状态">
            <template slot-scope="scope">
              <span>{{ getRiderStatus(scope.row.work_status)}}</span>
            </template>
        </el-table-column>
        <el-table-column
          label="送/总">
          <template slot-scope="scope">
            <span>{{scope.row.delivery_order_num}}</span> /
            <span>{{scope.row.total_order_num}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-bar">
        <el-pagination
          small
          @current-change="handleCurrentPageChange"
          :page-size="pagination.perpage"
          :current-page="currentPage"
          layout="prev, pager, next, total"
          :total="pagination.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { NAMESPACE } from '../store/modules/riderList';

export default {
  name: 'RiderList',
  data() {
    return {
      height: 500,
    };
  },
  computed: {
    ...mapState(NAMESPACE, [
      'list',
      'currentPage',
      'pagination',
      'riderStatusList',
      'workStatus',
    ]),
    ...mapState({
      timestamp: state => state.timestamp,
      date: ({ aside }) => aside.date,
    }),
    ...mapGetters(['AoiShopMsg']),
  },
  watch: {
    AoiShopMsg(val) {
      if (val) {
        this.getRiderListData();
      } else {
        // TODO RESET
        this.resetRiderListData();
      }
    },
    date() {
      this.getRiderListData();
    },
    timestamp() {
      this.getRiderListData();
    },
  },
  methods: {
    ...mapActions(NAMESPACE, [
      'handleCurrentPageChange',
      'getRiderListData',
      'handleSelectWorkStatus',
      'resetRiderListData',
    ]),
    getRiderStatus(status) {
      const riderStatus = this.riderStatusList.find(item => item.value === status);
      return riderStatus ? riderStatus.label : '';
    },
    handleRiderOrderMode(data) {
      const href = `rider.html?ridername=${data.rider_name}#/rider/ordermode/${data.rider_id}/${this.timestamp}`;
      window.open(href);
    },
  },
};
</script>

<style lang="less">
  .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: none;
  }
  .t-riderlist .t-rider-list .el-input--mini{
    width: 94px;
  }
  .el-table th {
    color: #666;
  }
  .el-table {
    color: #666;
  }
  .square-button {
    display: inline-block;
    background: #ff4d62;
    border-radius: 3px;
    color: #fff;
    padding: 2px;
    font-size: 12px;
    line-height: 12px;
    margin-right: 6px;
    cursor: pointer;
  }
  .red {
    background: #ff4d62;
  }
  .green {
    background: #87e37e;
  }
  .blue {
    background: #4A90E2;
  }
  .t-riderlist {
    background: #fff;
    width: 330px;
    padding: 20px 16px;
    display: flex;
    flex-direction: column;
    .t-rider-list {
      margin-bottom: 20px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      .t-rider-title {
        width: 96px;
        height: 33px;
        font-size: 24px;
      }
    }
    .t-rider-search {
      width: 125px;
    }
    .el-form-item__label {
      font-size: 12px;
    }
    .el-input--mini {
      width: 140px;
    }
    .el-table thead th {
      padding: 6px 0;
      background: #F6F6F6;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/homepage/modules/RiderList.vue